import { memo } from 'react';
import './CharacterWindow.scss'
import { useAppSelector } from '../../store/store';
import CharacterWindowStats from './CharacterWindowStats';
import CharacterWindowArmor from './CharacterWindowArmor';
import CharacterWindowWeapon from './CharacterWindowWeapon';
import CharacterWindowJewerly from './CharacterWindowJewerly';
import LevelBar from './LevelBar';
import ImgWithFallback from '../ui/ImgWithFallback';

interface ICharacterWindowProps {
    classIfInventoryOpen: string
    closeCharacterWindow: () => void
}

const CharacterWindow = ({ classIfInventoryOpen, closeCharacterWindow }: ICharacterWindowProps) => {
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    // ! do not delete const in next two line. Alert костЫль!!!)))))
    const inventoryLength = useAppSelector(state => state.userReducer.character.getInventory().getItems().length)
    const isEquipmentChange = useAppSelector(state => state.userReducer.isEquipmentChange)

    return (
        <div className={`character-window ${classIfInventoryOpen}`}>
            <div className="character-window__wrapper">
                <h1 className="character-window__title">Character</h1>
                <span
                    className='character-window__close'
                    onClick={closeCharacterWindow}>
                </span>
                <LevelBar level={mainCharacter.getLevel()} />
                <div className="character-window__body">
                    <div className="body__column">
                        <h3 className="body__column-name">
                            {mainCharacter.getName()}
                        </h3>
                        <div className="body__column-equipment equipment">
                            <CharacterWindowArmor />
                            <div className="equipment__character-img">
                                <ImgWithFallback
                                    src={mainCharacter.getImgBig().webp}
                                    fallbackSrc={mainCharacter.getImgBig().img} />
                            </div>
                            <ul className="equipment__slots">
                                <CharacterWindowJewerly />
                            </ul>
                        </div>
                        <div className="body__column-weapon">
                            <CharacterWindowWeapon />
                        </div>
                    </div>
                    <div className="body__column stats">
                        <CharacterWindowStats />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(CharacterWindow);
